import React, { useState, useMemo, useEffect } from 'react';
import { childrenPropTypes } from '../../utils/propTypesUtils';
import { useMutation } from '@apollo/react-hooks';
import { useRouter } from 'next/router';
import CC_RECORDING_REQUEST_MUTATION from './callCenterRecordingProvider/ccRecordingRequest.mutation.graphql';
import { useUserContext } from '@g4/next-furniture/UserContextProvider';

export const CallCenterRecordingData = React.createContext({});
export const useCallCenterRecordingState = () =>
  React.useContext(CallCenterRecordingData);

const CallCenterRecordingProvider = ({ children }) => {
  const [recordStatus, setRecordStatus] = useState('');
  const [actionRequest] = useMutation(CC_RECORDING_REQUEST_MUTATION);
  const { pathname } = useRouter();
  const { isImpersonation } = useUserContext();

  useEffect(() => {
    if (isImpersonation) {
      const isPaymentPage = /\/payment/.test(pathname);

      if (!isPaymentPage && recordStatus !== 'unmute') {
        actionRequest({ variables: { action: 'unmute' } });
        setRecordStatus('unmute');
      } else if (isPaymentPage && recordStatus !== 'mute') {
        actionRequest({ variables: { action: 'mute' } });
        setRecordStatus('mute');
      }
    }
  }, [actionRequest, isImpersonation, pathname, recordStatus]);

  const values = useMemo(() => {
    return {
      recordStatus,
      setRecordStatus,
      actionRequest,
    };
  }, [recordStatus, setRecordStatus, actionRequest]);

  return (
    <CallCenterRecordingData.Provider value={values}>
      {children}
    </CallCenterRecordingData.Provider>
  );
};
CallCenterRecordingProvider.propTypes = childrenPropTypes;

export default CallCenterRecordingProvider;
